// v1 starter Crew roster — 12 entries spanning archetypes.
// Trigger logic lives in the resolver, keyed by id, so adding new
// crew is one entry here + one switch arm in resolver.applyCrewTriggers.
export const CREW_LIBRARY = {
    quartermaster: {
        id: 'quartermaster',
        name: 'Quartermaster',
        archetype: 'reactor',
        description: 'When opponent plays a Double, you gain +1.',
        cost: 7,
        flavor: 'Counts every coin. Especially yours.',
    },
    powder_monkey: {
        id: 'powder_monkey',
        name: 'Powder Monkey',
        archetype: 'boarder',
        description: 'Your Sandwiches steal +1 extra (base 3 → 4 per copy).',
        cost: 8,
        flavor: 'Small hands, faster fuse.',
    },
    bosun: {
        id: 'bosun',
        name: 'Bosun',
        archetype: 'earner',
        description: '+1 from Treasury each turn.',
        cost: 6,
        flavor: 'Wakes the deck before sunrise.',
    },
    cabin_boy: {
        id: 'cabin_boy',
        name: 'Cabin Boy',
        archetype: 'earner',
        description: 'Your Marriages earn +2 extra (base 5 → 7 per copy).',
        cost: 7,
        flavor: 'Carries the rings.',
    },
    cooper: {
        id: 'cooper',
        name: 'Cooper',
        archetype: 'earner',
        description: 'Your Runs earn +1 per card in the run (Run of 4 → +4 extra).',
        cost: 9,
        flavor: 'Stacks barrels by feel.',
    },
    navigator: {
        id: 'navigator',
        name: 'Navigator',
        archetype: 'modifier',
        description: 'Your Suit chains can fire at length 2 (stealing 1 instead of the usual 2).',
        cost: 12,
        flavor: 'Knows the wind by smell.',
    },
    cursed_compass: {
        id: 'cursed_compass',
        name: 'Cursed Compass',
        archetype: 'modifier',
        description: 'Pay 1 each turn. Your Runs pay double base. (Each copy compounds: ×2, ×4, ×8 …)',
        cost: 8,
        flavor: 'Always points at gold. Sometimes yours.',
    },
    kraken_banner: {
        id: 'kraken_banner',
        name: 'Kraken Banner',
        archetype: 'comeback',
        description: 'Below 🪙10: your Mutinies steal double (8 → 16).',
        cost: 7,
        flavor: 'Hoisted only when sinking.',
    },
    bilge_rat: {
        id: 'bilge_rat',
        name: 'Bilge Rat',
        archetype: 'disruptor',
        description: 'When you play a Sandwich, opponent loses 1 card overboard next turn (gone for the match).',
        cost: 9,
        flavor: 'Lives between the planks.',
    },
    parrot: {
        id: 'parrot',
        name: 'Parrot',
        archetype: 'reactor',
        description: 'When opponent plays a Marriage, you gain +2.',
        cost: 7,
        flavor: 'Repeats everything. Especially the good parts.',
    },
    gunner: {
        id: 'gunner',
        name: 'Gunner',
        archetype: 'boarder',
        description: 'Your Royalty Stacks also steal 3 (per copy, on top of the discard effect).',
        cost: 9,
        flavor: 'Aims for the crown.',
    },
    smuggler: {
        id: 'smuggler',
        name: 'Smuggler',
        archetype: 'earner',
        description: 'When you play 5 cards in a turn, gain +3.',
        cost: 10,
        flavor: 'Pays in full. Eventually.',
    },
    // ── Earners (Tier-1 expansion) ─────────────────────────────────────
    cook: {
        id: 'cook',
        name: 'Cook',
        archetype: 'earner',
        description: 'When you play a turn with no patterns, gain +3.',
        cost: 5,
        flavor: 'A meal for nothing.',
    },
    carpenter: {
        id: 'carpenter',
        name: 'Carpenter',
        archetype: 'earner',
        description: '+1 each turn for every crew you have (including this one), capped at +5.',
        cost: 11,
        flavor: 'Builds you up, plank by plank.',
    },
    cartographer: {
        id: 'cartographer',
        name: 'Cartographer',
        archetype: 'earner',
        description: 'Your Runs of 4+ cards earn double base (Run of 4 → 8 instead of 4).',
        cost: 9,
        flavor: 'Charts the long way around.',
    },
    drunk_first_mate: {
        id: 'drunk_first_mate',
        name: 'Drunk First Mate',
        archetype: 'earner',
        description: 'Each Double you play pays +1 extra.',
        cost: 7,
        flavor: 'Doubles down. Always.',
    },
    stowaway: {
        id: 'stowaway',
        name: 'Stowaway',
        archetype: 'comeback',
        description: 'Below 🪙15: the first pattern you fire each turn earns +3 extra.',
        cost: 8,
        flavor: 'Knows every hull seam.',
    },
    last_stand: {
        id: 'last_stand',
        name: 'Last Stand',
        archetype: 'comeback',
        description: 'Below 🪙8: every steal you trigger is tripled (Sandwich 3 → 9, Mutiny 8 → 24).',
        cost: 10,
        flavor: "Nothing left but teeth.",
    },
    // ── Boarders ───────────────────────────────────────────────────────
    cutthroat: {
        id: 'cutthroat',
        name: 'Cutthroat',
        archetype: 'boarder',
        description: 'Your Sandwiches steal +2 extra per copy (stacks with Powder Monkey).',
        cost: 8,
        flavor: "Polite, until he isn't.",
    },
    boarding_hook: {
        id: 'boarding_hook',
        name: 'Boarding Hook',
        archetype: 'boarder',
        description: 'Every Steal pattern you trigger steals +1 extra (per copy).',
        cost: 10,
        flavor: 'Catches more than fish.',
    },
    pillager: {
        id: 'pillager',
        name: 'Pillager',
        archetype: 'boarder',
        description: 'When you steal 5+ in one turn, gain a +3 Treasury bonus.',
        cost: 9,
        flavor: 'The take after the take.',
    },
    // ── Reactors ───────────────────────────────────────────────────────
    spy: {
        id: 'spy',
        name: 'Spy',
        archetype: 'reactor',
        description: 'When opponent plays 5 cards in a turn, you gain +2.',
        cost: 10,
        flavor: "Watches when no one's watching.",
    },
    saboteur: {
        id: 'saboteur',
        name: 'Saboteur',
        archetype: 'reactor',
        description: 'When opponent plays a Run, you gain +1.',
        cost: 7,
        flavor: 'Slips a wedge in the works.',
    },
    tax_collector: {
        id: 'tax_collector',
        name: 'Tax Collector',
        archetype: 'reactor',
        description: 'When opponent earns 5+ in a turn, you skim +1.',
        cost: 11,
        flavor: "Doesn't ask.",
    },
    mirror_mage: {
        id: 'mirror_mage',
        name: 'Mirror Mage',
        archetype: 'reactor',
        description: 'When opponent plays a Sandwich, you steal 1 from them.',
        cost: 13,
        flavor: 'Reflection cuts both ways.',
    },
    // ── Disruptors ─────────────────────────────────────────────────────
    plague_rat: {
        id: 'plague_rat',
        name: 'Plague Rat',
        archetype: 'disruptor',
        description: 'When you play a Mutiny, opponent loses 4 cards overboard next turn (gone for the match).',
        cost: 11,
        flavor: "The whole hold's rotten.",
    },
    storm_caller: {
        id: 'storm_caller',
        name: 'Storm Caller',
        archetype: 'disruptor',
        description: "When you play a Run, opponent's first pattern next turn pays half (rounded down).",
        cost: 9,
        flavor: 'Fog over their charts.',
    },
    saltwater: {
        id: 'saltwater',
        name: 'Saltwater',
        archetype: 'disruptor',
        description: "When you play a Suit Chain, opponent draws to only 5 cards next turn (instead of 7).",
        cost: 8,
        flavor: 'The deck swims.',
    },
    // ── Modifiers ──────────────────────────────────────────────────────
    helmsman: {
        id: 'helmsman',
        name: 'Helmsman',
        archetype: 'modifier',
        description: 'Your Runs may have one single-rank gap (e.g., 5-7-8 or 5-6-8 counts as a Run of 3).',
        cost: 10,
        flavor: 'Plots his own course.',
    },
    shipwright: {
        id: 'shipwright',
        name: 'Shipwright',
        archetype: 'modifier',
        description: 'Your hand size is 8 instead of 7.',
        cost: 11,
        flavor: 'More room, more rope.',
    },
    dredge: {
        id: 'dredge',
        name: 'Dredge',
        archetype: 'modifier',
        description: 'At start of your turn, draw 1 extra card on top of the normal refill.',
        cost: 10,
        flavor: 'Pulls from the deep.',
    },
    bilge_pump: {
        id: 'bilge_pump',
        name: 'Bilge Pump',
        archetype: 'modifier',
        description: '+1 Toss & Redraw per copy (base 4 tosses/turn → 5, 6, 7…).',
        cost: 8,
        flavor: "Bails what shouldn't sink.",
    },
    coxswain: {
        id: 'coxswain',
        name: 'Coxswain',
        archetype: 'modifier',
        description: '+2 Toss & Redraw per copy (base 4 tosses/turn → 6, 8, 10…).',
        cost: 11,
        flavor: 'Steers the longboat through any swell.',
    },
    // ── Phase B: 12 new crew ───────────────────────────────────────────
    surgeon: {
        id: 'surgeon',
        name: 'Surgeon',
        archetype: 'comeback',
        description: 'On a turn you play no patterns, heal +2 hull at turn end (per copy).',
        cost: 7,
        flavor: 'Stitches first. Asks later.',
    },
    treasurer: {
        id: 'treasurer',
        name: 'Treasurer',
        archetype: 'earner',
        description: '+1 each turn for every crew you own (per copy), capped at +4 per copy. Stacks with Carpenter.',
        cost: 18,
        flavor: 'Knows the till to the copper.',
    },
    marauder: {
        id: 'marauder',
        name: 'Marauder',
        archetype: 'boarder',
        description: 'When you steal 6+ in a turn, opponent loses 1 card overboard (per copy).',
        cost: 10,
        flavor: 'Takes a finger with the ring.',
    },
    crows_nest: {
        id: 'crows_nest',
        name: "Crow's Nest",
        archetype: 'reactor',
        description: 'Once per turn, view AND reorder the top 3 cards of opponent\'s draw pile (each extra copy adds 1 to the visible count). Force them to draw garbage first.',
        cost: 10,
        flavor: 'Wind in your ear, glass on your eye.',
    },
    scribe: {
        id: 'scribe',
        name: 'Scribe',
        archetype: 'modifier',
        description: 'When you play a Suit Chain, draw +1 card at end of turn (per copy).',
        cost: 6,
        flavor: 'Logs every voyage. Even the boring ones.',
    },
    echo: {
        id: 'echo',
        name: 'Echo',
        archetype: 'earner',
        description: 'Your first pattern each turn fires twice (rule modifier — does not stack with extra copies).',
        cost: 17,
        flavor: 'Says it once, twice, always.',
    },
    watchman: {
        id: 'watchman',
        name: 'Watchman',
        archetype: 'comeback',
        description: 'First time per match you\'d take 8+ steal damage in one turn, prevent half (rounded down).',
        cost: 6,
        flavor: 'Sees it coming. Most of the time.',
    },
    vulture: {
        id: 'vulture',
        name: 'Vulture',
        archetype: 'reactor',
        description: 'When opponent loses a card overboard, you gain +1 (per copy of Vulture).',
        cost: 9,
        flavor: 'Patient. Eventually rich.',
    },
    powder_keg: {
        id: 'powder_keg',
        name: 'Powder Keg',
        archetype: 'boarder',
        description: 'Your Mutinies steal +4 extra (per copy), but you lose 2 hull each Mutiny you fire.',
        cost: 11,
        flavor: 'Light the wick and pray.',
    },
    foretelling: {
        id: 'foretelling',
        name: 'Foretelling',
        archetype: 'modifier',
        description: 'At draw-up, see the top 3 cards of your draw pile (no reorder; pure information).',
        cost: 8,
        flavor: 'The future is just paper, eventually.',
    },
    anchor: {
        id: 'anchor',
        name: 'Anchor',
        archetype: 'modifier',
        description: 'Opponent\'s next-turn flag effects (Storm Caller, Saltwater) don\'t apply to you.',
        cost: 7,
        flavor: 'Won\'t budge for any tide.',
    },
    chronicler: {
        id: 'chronicler',
        name: 'Chronicler',
        archetype: 'earner',
        description: 'At end of turn, gain +1 for each distinct pattern type you have ever played this match (capped at 5).',
        cost: 15,
        flavor: 'Every line of the saga is its own coin.',
    },
    tactician: {
        id: 'tactician',
        name: 'Tactician',
        archetype: 'modifier',
        description: 'Before resolution, your plank is auto-arranged for maximum value. The order you played in is overridden.',
        cost: 16,
        flavor: 'Sees the whole board half a beat early.',
    },
    // ── Captain signature crew (only available via run-start) ──────────
    iron_cleaver: {
        id: 'iron_cleaver',
        name: 'Iron Cleaver',
        archetype: 'boarder',
        description: 'Your Mutinies steal +5. Cannot be sold (signature gear).',
        cost: 0,
        flavor: 'Etched with the names of every captain it served.',
    },
    goldhand: {
        id: 'goldhand',
        name: 'Goldhand',
        archetype: 'earner',
        description: 'For every 5 doubloons you earn in a turn, gain +2 bonus (per copy).',
        cost: 0,
        flavor: 'Touches gold, leaves more behind.',
    },
    tideborn_navigator: {
        id: 'tideborn_navigator',
        name: 'Tideborn Navigator',
        archetype: 'modifier',
        description: 'Suit Chains fire at length 2 (stealing 2 instead of 1). Stacks with Navigator.',
        cost: 0,
        flavor: 'Reads currents like sentences.',
    },
    stormbinder: {
        id: 'stormbinder',
        name: 'Stormbinder',
        archetype: 'disruptor',
        description: "When you play any pattern, opponent's next Port pick costs +2🪙.",
        cost: 0,
        flavor: 'Calls the wind down on slow buyers.',
    },
    saltbound_surgeon: {
        id: 'saltbound_surgeon',
        name: 'Saltbound Surgeon',
        archetype: 'comeback',
        description: 'Heal +3 hull on a turn you play no patterns (instead of Surgeon\'s +2).',
        cost: 0,
        flavor: 'Stitches with seaweed and salt.',
    },
};
export function getCrew(id) {
    return CREW_LIBRARY[id];
}
export function allCrewIds() {
    return Object.keys(CREW_LIBRARY);
}
